import React, { Component } from 'react';
// import { Link } from 'react-router-dom';
// import axios from 'axios';
// import { decode } from 'html-entities';

export class MainNav extends Component  {
  navElement = null
  handleNavClick = null

  componentDidMount() {
    this.navElement = document.querySelector('#main-nav');

    if (!this.navElement) {
      return;
    }

    this.handleNavClick = (event) => {
      if (!event.target.closest('a')) {
        return;
      }

      this.navElement.classList.remove('open');
    };

    this.navElement.addEventListener('click', this.handleNavClick);
  }

  componentWillUnmount() {
    if (this.navElement && this.handleNavClick) {
      this.navElement.removeEventListener('click', this.handleNavClick);
    }
  }

  render() {
    return (
      <>
        <nav id="main-nav" className="slidingNav">

          <ul>
            <li><p>St. Augustine, Florida</p></li>
            <li><a href="/st-augustine/apartment-listings"><i className="fa fa-building"></i> Apartment Listings</a></li>
            <li><a href="/st-augustine/faqs"><i className="fa fa-question"></i> FAQs</a></li>

            <li><p>Miami, Florida</p></li>
            <li><a href="/miami/apartment-listings"><i className="fa fa-building"></i> Apartment Listings</a></li>
            <li><a href="/miami/faqs"><i className="fa fa-question"></i> FAQs</a></li>

            <li><p>Austin, Texas</p></li>
            <li><a href="/austin/apartment-listings"><i className="fa fa-building"></i> Apartment Listings</a></li>
            <li><a href="/austin/faqs"><i className="fa fa-question"></i> FAQs</a></li>

            <li><p>Dallas, Texas</p></li>
            <li><a href="/dallas/apartment-listings"><i className="fa fa-building"></i> Apartment Listings</a></li>
            <li><a href="/dallas/faqs"><i className="fa fa-question"></i> FAQs</a></li>

            <li><p>San Marcos, California</p></li>
            <li><a href="/san-marcos/apartment-listings"><i className="fa fa-building"></i> Apartment Listings</a></li>
            <li><a href="/san-marcos/faqs"><i className="fa fa-question"></i> FAQs</a></li>
          </ul>

          <div className="nav-copyright">
            <img src={process.env.PUBLIC_URL + '/global/images/logos/usa-logo-whitesm.png'} alt="University of St. Augustine for Health Sciences" />
          </div>
        </nav>
      </>
    );
  }
}

export default MainNav;